// src/demos/registry.ts
//
// What is left of the bundled demos the on-device engine used to run.
//
// Saddle now generates mobile-native WEB apps, so the demos a new person sees are real
// published pages — see `webDemos.ts`, which is what My Apps lists. The two that shipped
// here were AppDefinitions the engine ran out of local SQLite, one of them wired to
// HealthKit; both still worked and both showed a product that no longer exists.
//
// The `demo:` routing stays because installs made before this change still hold those rows
// in their local database, and an id that was reserved must keep resolving where it always
// did. Nothing new is seeded, so on a fresh install this set is simply empty.
import type { AppDefinition } from '@/types/app';
import type { EntitySchema } from '@/types/schema';
import type { AppListing } from '@/backend/types';

export const DEMO_APP_ID_PREFIX = 'demo:';

/** A bundled demo the local engine runs: its definition, schemas, and seed records. */
export interface DemoSpec {
  listing: AppListing;
  definition: AppDefinition;
  schemas: EntitySchema[];
  seedRecords: Record<string, Record<string, unknown>[]>;
  version: number;
}

/** Empty by design. New demos are published web apps, not engine definitions. */
export const DEMOS: DemoSpec[] = [];

/** True for a reserved bundled-demo appId (routes to the local backend, never the server). */
export function isDemoAppId(appId: string | undefined | null): boolean {
  return typeof appId === 'string' && appId.startsWith(DEMO_APP_ID_PREFIX);
}

export function getDemo(appId: string): DemoSpec | undefined {
  return DEMOS.find((d) => d.definition.id === appId);
}
